import styled from 'styled-components';

export default comp => styled(comp)`
  picture {
    display: block;
    max-width: 700px;
    margin: 3rem auto;
  }

  .block-disclaimer {
    > .inner {
      @media (min-width: ${props => props.theme.breakpoints.desktop}) {
        max-width: ${props => props.theme.maxWidths.accordion};
      }
    }
  }

  .block-accordion {
    .inner {
      .items {
        li {
          a {
            display: inline;
          }
        }
      }

      .item-content {
        > div > * {
          &:last-child {
            margin-bottom: 2rem;
          }
        }

        ul {
          list-style-type: disc;
        }
      }
    }
  }

`;
